import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import LibModal from '../../../features/LibModal/LibModal';
import NotFound from '../../../features/NotFound/NotFoundPage';
import { useTemplate } from '../../../features/template/TemplateProvider';
import PageTitle from '../../../utils/PageTitle';
import { GetSearchParams } from '../../../utils/URL';
import AddIssueTicketModal from '../../SupportTicket/Modals/AddIssueTicketModal';
import MakeDoneModal from '../Manage/Modals/MakeDoneModal';
import MakeImplementModal from '../Manage/Modals/MakeImplementModal';
import MakeIteration from '../Manage/Modals/MakeIteration';
import MakeOngoingModal from '../Manage/Modals/MakeOngoingModal';
import ViewServiceActivityLogModal from '../Manage/Modals/ViewServiceActivityLogModal';
import ServiceInfo from './Components/ServiceInfo';
import ServiceTableTab from './Components/ServiceTableTab';
import ServiceActivityPage from './Components/ServiceTabTables/Activity/ServiceActivityPage';
import ServiceInvoicesPage from './Components/ServiceTabTables/Invoices/ServiceInvoicesPage';
import ServicePaymentsPage from './Components/ServiceTabTables/Payments/ServicePaymentsPage';
import ModalRenewService from './Modals/ModalRenewService';
import ServiceInfoProvider, { useServiceInfo } from './ServiceInfoProvider';

function TabComponentRender({ data }) {
    const tabName = GetSearchParams('tab') || 'invoices';

    switch (tabName) {
        case 'invoices':
            return <ServiceInvoicesPage data={data?.invoices || []} />;
        case 'payments':
            return <ServicePaymentsPage data={data?.transactions || []} />;
        case 'activity':
            return <ServiceActivityPage data={data?.activityLog || []} />;
        default:
            return null;
    }
}

function PageCont() {
    const { serviceInfoData, handleReload, openModal, closeModal, modalType } = useServiceInfo();
    const { setConfirm } = useTemplate();
    const [showActivityModal, setShowActivityModal] = useState(false);
    const [supportTicketData, setSupportTicketData] = useState({
        user: 0,
        service: 0
    });

    // if no data found
    if (serviceInfoData && Object.keys(serviceInfoData).length === 0) {
        return (
            <div className="inner_page_cont">
                <NotFound
                    title="No Service Found!"
                    btnTitle="Back to list"
                    path="/services/manage"
                    className="h-full"
                />
            </div>
        );
    }

    const serviceData = { ...serviceInfoData?.serviceInfo, user: serviceInfoData?.user };

    const handleActionClick = (action) => {
        switch (action) {
            case 'make-implement':
                setConfirm({
                    showButton: false,
                    text: <MakeImplementModal data={serviceData} handleReload={handleReload} />
                });
                break;
            case 'make-ongoing':
                setConfirm({
                    showButton: false,
                    text: <MakeOngoingModal data={serviceData} handleReload={handleReload} />
                });
                break;
            case 'make-done':
                setConfirm({
                    showButton: false,
                    text: <MakeDoneModal data={serviceData} handleReload={handleReload} />
                });
                break;
            case 'make-iteration':
                setConfirm({
                    showButton: false,
                    text: <MakeIteration data={serviceData} handleReload={handleReload} />
                });
                break;
            case 'renew-service':
                openModal('renew-service', serviceData);
                break;
            case 'create-support-ticket':
                setSupportTicketData({
                    user: serviceInfoData?.user?.id,
                    service: serviceInfoData?.serviceInfo?.id
                });
                break;
            default:
                break;
        }
    };

    const closeSupportTicketModal = () => {
        setSupportTicketData({
            user: 0,
            service: 0
        });
    };

    return (
        <div className="service_info_page inner_page_cont">
            <ServiceInfo data={serviceData} handleReload={handleReload} openModal={openModal} />

            <ServiceTableTab
                data={serviceInfoData?.serviceInfo}
                onActionClick={handleActionClick}
            />

            <TabComponentRender data={serviceInfoData} />

            {/* Renew Service Modal */}
            {modalType === 'renew-service' && (
                <LibModal title="Renew Service" setOpen={closeModal} className="md:!w-[800px]">
                    <ModalRenewService
                        serviceInfoData={serviceInfoData}
                        handleReload={handleReload}
                        closeModal={closeModal}
                    />
                </LibModal>
            )}

            {/* View Activity Log Modal */}
            {showActivityModal && (
                <LibModal
                    title="Service Activity Log"
                    setOpen={setShowActivityModal}
                    className="md:!w-[900px]"
                >
                    <ViewServiceActivityLogModal serviceId={serviceInfoData?.serviceInfo?.id} />
                </LibModal>
            )}

            {/* Create Support Ticket Modal */}
            {supportTicketData.user !== 0 && (
                <LibModal title="Create Support Ticket" setOpen={closeSupportTicketModal}>
                    <AddIssueTicketModal
                        userId={supportTicketData.user}
                        serviceId={supportTicketData.service}
                        closeModal={closeSupportTicketModal}
                        handleReload={handleReload}
                        type="service"
                    />
                </LibModal>
            )}
        </div>
    );
}

function ServiceInfoPage() {
    const { id } = useParams();

    // set page title
    PageTitle(`Service Info - ${id}`);

    return (
        <ServiceInfoProvider serviceId={id}>
            <PageCont serviceId={id} />
        </ServiceInfoProvider>
    );
}

export default ServiceInfoPage;
